module.exports = __webpack_public_path__ + "static/media/icon-mail-type02.924e43b9.svg";